import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-visit-start-modal',
  templateUrl: './visit-start-modal.component.html',
  styleUrls: ['./visit-start-modal.component.scss'],
})
export class VisitStartModalComponent {
  public visit: any = {};
  private onShowInstructionsCallback: (referenceId: string) => void;
  private onShowEmergencyPlanCallback: (referenceId: string) => void;

  constructor(
    public dialogRef: MatDialogRef<VisitStartModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any | null
  ) {
    if (data) {
      this.visit = data.visit || {};
      this.onShowInstructionsCallback = data.onShowInstructions;
      this.onShowEmergencyPlanCallback = data.onShowEmergencyPlan;
    }
    dialogRef.disableClose = true;
  }

  onShowInstructions() {
    const referenceId = this.visit.lmraReferenceId;

    if (referenceId && this.onShowInstructionsCallback) {
      this.onShowInstructionsCallback(referenceId);
    }
  }

  onShowEmergencyPlan() {
    const referenceId = this.visit.safetyPlanReferenceId;

    if (referenceId && this.onShowEmergencyPlanCallback) {
      this.onShowEmergencyPlanCallback(referenceId);
    }
  }

  onProceed() {
    this.dialogRef.close({ action: 'proceed' });
  }
}
